import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { actions } from './actions';
import { WASH_DEFAULT_STATE } from './constants';

const completedState = completeState(WASH_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [actions.GET_ALL_ADDED_WASHES, actions.ADD_WASH],
  override: { [actions.SET_CURRENT_WASH]: onReadValue() }
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
